
import { CreateElement, VNode } from 'vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { elevationCss, radius } from '../Token/token';
import { appendPx } from '../Token/helper/tokenHelper';

/**
 * Card skeleton.
 */
export default Vue.extend({
  name: 'Card',
  props: {
    /**
     * Shadow of the button.<br />
     * Possible value `flat` | `container` | `interactive`
     * | `float` | `hover`<br />
     * From left to right, shadow will be bigger
     */
    elevation: {
      type: String,
      default: 'container'
    },
    /**
     * Error state of the card.
     */
    error: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      /**
       * Handle when user click the button.
       * @event click
       * @type {function}
       */
      this.$emit('click');
    }
  },
  render(h: CreateElement): VNode {
    return h(
      'div',
      {
        class: {
          card: true,
          error: this.error
        },
        style: {
          boxShadow: elevationCss[this.elevation],
          borderRadius: appendPx(radius.default),
          background: 'white',
          transition: 'all .2s'
        },
        // nativeOn: {
        //   click: this.handleClick,
        // },
        on: {
          click: this.handleClick
        },
        attrs: {
          ...this.$attrs
        }
      },
      [
        /**
         * @slot Content of the card
         */
        this.$slots.default
      ]
    );
  }
});
